import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  body,
  action,
}: EmptyStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-box border border-base-300 bg-base-200 p-8 text-center"
      role="status"
    >
      {icon && (
        <div className="text-4xl text-base-content/60" aria-hidden="true">
          {icon}
        </div>
      )}
      <p className="text-base font-semibold text-base-content">{title}</p>
      {body && <p className="text-sm text-base-content/70">{body}</p>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
